import React, { useRef, useState } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from '@material-ui/core';
import { PictureAsPdf as PdfIcon } from '@material-ui/icons';

interface SignatureCanvasProps {
  open: boolean;
  onClose: () => void;
  onSave: (signature: string) => void;
  pdfUrl: string;
}

const SignatureCanvasComponent: React.FC<SignatureCanvasProps> = ({ open, onClose, onSave, pdfUrl }) => {
  const sigCanvas = useRef<SignatureCanvas>(null);
  const [isEmpty, setIsEmpty] = useState(true);

  const clear = () => {
    sigCanvas.current?.clear();
    setIsEmpty(true);
  };

  const save = () => {
    if (sigCanvas.current) {
      const signatureData = sigCanvas.current.toDataURL();
      onSave(signatureData);
      onClose();
    }
  };

  const openPdf = () => {
    window.open(pdfUrl, '_blank');
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
     <DialogTitle>
      Desenhe sua assinatura
      <Button
        onClick={openPdf}
        style={{ float: 'right' }}
        startIcon={<PdfIcon />}
        color="primary"
      >
        Visualizar Termo
      </Button>
    </DialogTitle>
      <DialogContent>
        <SignatureCanvas
          ref={sigCanvas}
          canvasProps={{
            width: 500,
            height: 200,
            className: 'signature-canvas'
          }}
          onBegin={() => setIsEmpty(false)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={clear} color="secondary">
          Limpar
        </Button>
        <Button onClick={onClose} color="primary">
          Cancelar
        </Button>
        <Button onClick={save} color="primary" disabled={isEmpty}>
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SignatureCanvasComponent;
